import React, { useState } from 'react'
import { AboutInnerBanner } from '../../Components/Common/InnerBanner/AboutInnerBanner'
import AboutInnBanContent from '../../Components/Common/InnerBanner/AboutInnBanContent'
import Transition from '../../Components/Transition'
import { Helmet } from 'react-helmet'

// ─── Keyword Data ──────────────────────────────────────────────────────────────
const keywordData = [
  {
    id: 'general-fertility-services',
    category: 'General Fertility Services',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
    color: '#c02b3f',
    bgColor: '#fdecea',
    pillStyle: 'dark',
    keywords: [
      'Fertility Clinic Near Me',
      'Best Fertility Clinic',
      'Best Fertility Clinic Near Me',
      'Fertility Specialist',
      'Fertility Specialist Near Me',
    ],
  },
  {
    id: 'fertility-tests',
    category: 'Fertility Tests',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
      </svg>
    ),
    color: '#155724',
    bgColor: '#eaf4ed',
    pillStyle: 'green',
    keywords: [
      'Fertility Test',
      'Fertility Test For Women',
    ],
  },
  {
    id: 'ivf-services',
    category: 'IVF (In Vitro Fertilization) Services',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 8v4l3 3"/>
      </svg>
    ),
    color: '#1a5276',
    bgColor: '#eaf2fb',
    pillStyle: 'blue',
    keywords: [
      'IVF Near Me',
      'IVF Clinic Near Me',
      'IVF Fertility Clinic',
      'IVF Treatment Near Me',
      'Best IVF Fertility Treatment',
    ],
  },
  {
    id: 'ivf-by-location',
    category: 'IVF by Location',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
        <circle cx="12" cy="10" r="3"/>
      </svg>
    ),
    color: '#6c3483',
    bgColor: '#f5eef8',
    pillStyle: 'purple',
    keywords: [
      'Best IVF Centre In Mumbai',
      'Best Fertility Clinic In Mumbai',
      'ICSI Treatment In Mumbai',
      'Best IVF Clinic In India',
    ],
  },
  {
    id: 'treatment-cost-procedures',
    category: 'Treatment Cost & Procedures',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    ),
    color: '#0e7c86',
    bgColor: '#e0f7f9',
    pillStyle: 'teal',
    keywords: [
      'IVF Treatment Cost In India',
      'IUI Treatment Near Me',
    ],
  },
  {
    id: 'gynecology-womens-health',
    category: "Gynecology / Women's Health",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
      </svg>
    ),
    color: '#b45309',
    bgColor: '#fef3c7',
    pillStyle: 'amber',
    keywords: [
      'Best Gynecologist Near Me',
    ],
  },
]

const pillStyles = {
  dark:   { background: '#1a2e44', color: '#ffffff' },
  green:  { background: '#1e8449', color: '#ffffff' },
  blue:   { background: '#1a5276', color: '#ffffff' },
  purple: { background: '#6c3483', color: '#ffffff' },
  teal:   { background: '#0e7c86', color: '#ffffff' },
  amber:  { background: '#b45309', color: '#ffffff' },
}

// ─── Search Bar ────────────────────────────────────────────────────────────────
const SearchBar = ({ value, onChange }) => (
  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '32px' }}>
    <div style={{ position: 'relative', width: '100%', maxWidth: '520px' }}>
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder="Search keywords..."
        style={{
          width: '100%',
          padding: '12px 48px 12px 20px',
          fontSize: '15px',
          border: '1.5px solid #1a7ab5',
          borderRadius: '999px',
          outline: 'none',
          boxSizing: 'border-box',
          color: '#1a2e44',
          background: '#fff',
          fontFamily: 'inherit',
        }}
      />
      <span style={{
        position: 'absolute', right: '18px', top: '50%',
        transform: 'translateY(-50%)', color: '#1a7ab5',
        display: 'flex', alignItems: 'center',
      }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"/>
          <line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
      </span>
    </div>
  </div>
)

// ─── Keyword Card ──────────────────────────────────────────────────────────────
const KeywordCard = ({ category, icon, color, bgColor, pillStyle, keywords, query }) => {
  const q = query.trim().toLowerCase()
  const filtered = q
    ? keywords.filter(k => k.toLowerCase().includes(q))
    : keywords

  if (filtered.length === 0) return null

  return (
    <div style={{
      background: '#ffffff',
      border: '1px solid #e8eaf0',
      borderRadius: '14px',
      padding: '22px 28px 24px',
      marginBottom: '20px',
      boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
    }}>
      {/* Category Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px' }}>
        <div style={{ width: '3px', height: '22px', background: color, borderRadius: '2px', flexShrink: 0 }} />
        <span style={{ color, display: 'flex', alignItems: 'center' }}>{icon}</span>
        <span style={{
          fontSize: '13px', fontWeight: '700',
          letterSpacing: '0.08em', color: '#1a2e44', textTransform: 'uppercase',
        }}>
          {category}
        </span>
        <span style={{
          marginLeft: '4px', fontSize: '12px', fontWeight: '600',
          background: bgColor, color, borderRadius: '999px',
          padding: '2px 9px', minWidth: '22px', textAlign: 'center',
        }}>
          {filtered.length}
        </span>
      </div>

      {/* Keyword Pills */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        {filtered.map(keyword => (
          <span
            key={keyword}
            style={{
              ...(pillStyles[pillStyle] || pillStyles.dark),
              borderRadius: '999px',
              padding: '8px 18px',
              fontSize: '13.5px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'opacity 0.15s',
              display: 'inline-block',
              lineHeight: 1,
            }}
            onMouseEnter={e => (e.currentTarget.style.opacity = '0.82')}
            onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
          >
            {keyword}
          </span>
        ))}
      </div>
    </div>
  )
}

// ─── Keywords Section ──────────────────────────────────────────────────────────
const KeywordsSection = () => {
  const [query, setQuery] = useState('')

  const totalKeywords = keywordData.reduce((acc, cat) => acc + cat.keywords.length, 0)

  const hasNoResults =
    query.trim().length > 0 &&
    keywordData.every(
      cat => cat.keywords.filter(k =>
        k.toLowerCase().includes(query.trim().toLowerCase())
      ).length === 0
    )

  return (
    <div style={{
      maxWidth: '900px',
      margin: '0 auto',
      padding: '48px 24px 64px',
      fontFamily: "'Segoe UI', Arial, sans-serif",
    }}>
      {/* Section Title */}
      <div style={{ textAlign: 'center', marginBottom: '36px' }}>
        <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1a2e44', marginBottom: '8px' }}>
          Our Keywords
        </h2>
        <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>
          {totalKeywords} keywords across {keywordData.length} categories
        </p>
      </div>

      {/* Search */}
      <SearchBar value={query} onChange={setQuery} />

      {/* Cards */}
      {keywordData.map(cat => (
        <KeywordCard key={cat.id} {...cat} query={query} />
      ))}

      {/* Empty State */}
      {hasNoResults && (
        <div style={{ textAlign: 'center', padding: '48px 0', color: '#9ca3af' }}>
          <p style={{ fontSize: '16px' }}>
            No keywords match &ldquo;<strong>{query}</strong>&rdquo;
          </p>
        </div>
      )}
    </div>
  )
}

// ─── Page Component ────────────────────────────────────────────────────────────
const OurKeyWords = () => {
  const { image, heading, pageName } = AboutInnBanContent.OurKeyWords

  return (
    <>
      <Helmet>
        <title>Our Keywords | ACME Fertility, Chembur</title>
        <meta name='description' content='Explore ACME Fertility keywords covering IVF, fertility clinics, gynecology, and more in Mumbai and Chembur.' />
        <meta name='keywords' content='Acme fertility, IVF Mumbai, Best fertility clinic near me, fertility specialist, IUI, ICSI, gynecologist Mumbai' />
        <link rel="canonical" href="https://www.acmefertility.com/OurKeyWords" />
        <meta name="robots" content="Index, follow" />
      </Helmet>

      <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

      <KeywordsSection />
    </>
  )
}

export default Transition(OurKeyWords)